export const manufacturers = [
  {
    id: 1,
    name: '보령해양산업',
    region: '충남 보령',
    category: '어구류 전문',
    established: 2005,
    description: '서해안 최대 규모의 어구 제조업체로 그물, 로프, 부표 등 다양한 어구를 생산합니다.',
    specialties: ['트롤 그물', '자망', '통발', '부표'],
    certifications: ['ISO 9001', '해양수산부 우수업체', 'KC 인증'],
    employees: 45,
    annualProduction: '연 15억원',
    mainClients: ['한국원양산업', '대림수산', '남해수산'],
    contact: {
      phone: '041-932-5678',
      email: 'info@boryeongmarine.co.kr',
      address: '충청남도 보령시 오천면 해안로 234'
    },
    image: 'https://public.readdy.ai/ai/img_res/8f3ac011f270bef50f714884e2868535.jpg',
    rating: 4.8,
    reviewCount: 127
  },
  {
    id: 2,
    name: '부산마린테크',
    region: '부산 영도구',
    category: '갑판용품 전문',
    established: 1998,
    description: '30년 전통의 갑판용품 전문 제조업체로 Wire, Block, Shackle 등 고품질 제품을 공급합니다.',
    specialties: ['스테인리스 Wire', '대형 Block', 'Shackle', '윈치'],
    certifications: ['ISO 9001', 'KS 인증', '선급 인증'],
    employees: 62,
    annualProduction: '연 25억원',
    mainClients: ['한국원양산업', '대림수산', '한성기업'],
    contact: {
      phone: '051-403-7890',
      email: 'sales@busanmarine.co.kr',
      address: '부산광역시 영도구 해양로 156'
    },
    image: 'https://readdy.ai/api/search-image?query=professional%20marine%20hardware%20manufacturing%20workshop%20with%20stainless%20steel%20wire%20blocks%20and%20shackles%20organized%20display%20modern%20industrial%20facility&width=800&height=600&seq=manu2&orientation=landscape',
    rating: 4.9,
    reviewCount: 203
  },
  {
    id: 3,
    name: '목포해양기계',
    region: '전남 목포',
    category: '기관물품 전문',
    established: 2001,
    description: '선박 엔진 부품 및 기관실 소모품 전문 제조업체로 고품질 제품을 합리적인 가격에 공급합니다.',
    specialties: ['엔진 필터', '유압 호스', '펌프 부품', '냉각 시스템'],
    certifications: ['ISO 9001', 'KS 인증', '해양수산부 인증'],
    employees: 38,
    annualProduction: '연 12억원',
    mainClients: ['대림수산', '한성기업', '남해수산'],
    contact: {
      phone: '061-244-3456',
      email: 'contact@mokpomarine.co.kr',
      address: '전라남도 목포시 해안대로 567'
    },
    image: 'https://readdy.ai/api/search-image?query=marine%20engine%20parts%20manufacturing%20facility%20with%20filters%20pumps%20and%20hydraulic%20components%20organized%20warehouse%20clean%20industrial%20environment&width=800&height=600&seq=manu3&orientation=landscape',
    rating: 4.7,
    reviewCount: 156
  },
  {
    id: 4,
    name: '여수어구제작소',
    region: '전남 여수',
    category: '어구류 전문',
    established: 1995,
    description: '남해안 대표 어구 제작소로 맞춤형 어구 제작 및 수리 서비스를 제공합니다.',
    specialties: ['선망', '저인망', '채낚기', '주낙'],
    certifications: ['해양수산부 우수업체', 'KC 인증'],
    employees: 52,
    annualProduction: '연 18억원',
    mainClients: ['한성기업', '남해수산', '제주수협'],
    contact: {
      phone: '061-685-2345',
      email: 'yeosu@fishgear.co.kr',
      address: '전라남도 여수시 수산로 123'
    },
    image: 'https://readdy.ai/api/search-image?query=fishing%20gear%20workshop%20with%20nets%20ropes%20and%20fishing%20equipment%20traditional%20craftsmanship%20meets%20modern%20production%20coastal%20setting&width=800&height=600&seq=manu4&orientation=landscape',
    rating: 4.6,
    reviewCount: 142
  },
  {
    id: 5,
    name: '통영해양공업',
    region: '경남 통영',
    category: '갑판용품 전문',
    established: 2003,
    description: '갑판 안전장비 및 작업용품 전문 제조업체로 선원 안전을 최우선으로 합니다.',
    specialties: ['안전 난간', '작업대', '로프 릴', '갑판 조명'],
    certifications: ['ISO 9001', 'KS 인증', '안전인증'],
    employees: 41,
    annualProduction: '연 14억원',
    mainClients: ['한국원양산업', '대림수산', '한성기업'],
    contact: {
      phone: '055-645-8901',
      email: 'info@tongyeongmarine.co.kr',
      address: '경상남도 통영시 항남로 89'
    },
    image: 'https://readdy.ai/api/search-image?query=marine%20deck%20equipment%20manufacturing%20facility%20with%20safety%20railings%20work%20platforms%20and%20deck%20lighting%20modern%20industrial%20workshop&width=800&height=600&seq=manu5&orientation=landscape',
    rating: 4.8,
    reviewCount: 178
  },
  {
    id: 6,
    name: '포항철강마린',
    region: '경북 포항',
    category: '갑판용품 전문',
    established: 2000,
    description: '철강 가공 기술을 바탕으로 고강도 갑판용품을 제조하는 전문업체입니다.',
    specialties: ['스테인리스 체인', '앵커', '볼라드', '클리트'],
    certifications: ['ISO 9001', 'KS 인증', '선급 인증'],
    employees: 55,
    annualProduction: '연 22억원',
    mainClients: ['한국원양산업', '한성기업', '대림수산'],
    contact: {
      phone: '054-278-4567',
      email: 'sales@pohangsteel.co.kr',
      address: '경상북도 포항시 남구 해안로 345'
    },
    image: 'https://readdy.ai/api/search-image?query=steel%20marine%20equipment%20manufacturing%20plant%20with%20chains%20anchors%20and%20bollards%20heavy%20duty%20industrial%20facility%20modern%20metalworking&width=800&height=600&seq=manu6&orientation=landscape',
    rating: 4.9,
    reviewCount: 195
  },
  {
    id: 7,
    name: '제주해양산업',
    region: '제주',
    category: '어구류 전문',
    established: 2008,
    description: '제주 특화 어구 제작 및 원양어선용 대형 어구를 전문으로 제조합니다.',
    specialties: ['참치 연승', '오징어 채낚기', '대형 트롤', '부표'],
    certifications: ['해양수산부 우수업체', 'ISO 9001'],
    employees: 48,
    annualProduction: '연 16억원',
    mainClients: ['한국원양산업', '제주수협', '남해수산'],
    contact: {
      phone: '064-742-5678',
      email: 'jeju@marinegear.co.kr',
      address: '제주특별자치도 제주시 해안동 234'
    },
    image: 'https://readdy.ai/api/search-image?query=island%20fishing%20equipment%20manufacturing%20facility%20with%20tuna%20longline%20gear%20and%20squid%20jigging%20equipment%20coastal%20workshop%20tropical%20setting&width=800&height=600&seq=manu7&orientation=landscape',
    rating: 4.7,
    reviewCount: 134
  },
  {
    id: 8,
    name: '인천해양기계',
    region: '인천',
    category: '기관물품 전문',
    established: 1997,
    description: '선박 기관실 전문 부품 제조 및 정비 서비스를 제공하는 종합 업체입니다.',
    specialties: ['디젤 엔진 부품', '발전기', '냉동기', '공조 시스템'],
    certifications: ['ISO 9001', 'KS 인증', '선급 인증'],
    employees: 67,
    annualProduction: '연 28억원',
    mainClients: ['한국원양산업', '대림수산', '한성기업'],
    contact: {
      phone: '032-765-3456',
      email: 'incheon@marinemachine.co.kr',
      address: '인천광역시 중구 항동 567'
    },
    image: 'https://readdy.ai/api/search-image?query=marine%20engine%20parts%20warehouse%20with%20diesel%20engine%20components%20generators%20and%20refrigeration%20systems%20professional%20industrial%20facility&width=800&height=600&seq=manu8&orientation=landscape',
    rating: 4.8,
    reviewCount: 187
  },
  {
    id: 9,
    name: '울산해양로프',
    region: '울산',
    category: '어구류 전문',
    established: 2004,
    description: '고강도 로프 및 와이어 전문 제조업체로 다양한 규격의 제품을 생산합니다.',
    specialties: ['나일론 로프', '폴리에스터 로프', 'Wire Rope', '계류 로프'],
    certifications: ['ISO 9001', 'KS 인증', '해양수산부 인증'],
    employees: 43,
    annualProduction: '연 13억원',
    mainClients: ['대림수산', '한성기업', '남해수산'],
    contact: {
      phone: '052-234-6789',
      email: 'ulsan@marinerope.co.kr',
      address: '울산광역시 동구 해양로 234'
    },
    image: 'https://readdy.ai/api/search-image?query=rope%20manufacturing%20facility%20with%20large%20spools%20of%20nylon%20and%20polyester%20ropes%20wire%20rope%20production%20modern%20textile%20industrial%20plant&width=800&height=600&seq=manu9&orientation=landscape',
    rating: 4.6,
    reviewCount: 149
  },
  {
    id: 10,
    name: '군산어구산업',
    region: '전북 군산',
    category: '어구류 전문',
    established: 2006,
    description: '서해안 어업 특성에 맞는 어구를 전문으로 제작하는 업체입니다.',
    specialties: ['꽃게 통발', '새우 트롤', '갈치 낚시', '주꾸미 채낚기'],
    certifications: ['해양수산부 우수업체', 'KC 인증'],
    employees: 36,
    annualProduction: '연 11억원',
    mainClients: ['군산수협', '서해수산', '한성기업'],
    contact: {
      phone: '063-468-2345',
      email: 'gunsan@fishgear.co.kr',
      address: '전라북도 군산시 해망로 456'
    },
    image: 'https://readdy.ai/api/search-image?query=coastal%20fishing%20gear%20workshop%20with%20crab%20traps%20shrimp%20trawl%20nets%20and%20fishing%20equipment%20traditional%20korean%20fishing%20gear%20manufacturing&width=800&height=600&seq=manu10&orientation=landscape',
    rating: 4.5,
    reviewCount: 118
  },
  {
    id: 11,
    name: '창원정밀기계',
    region: '경남 창원',
    category: '기관물품 전문',
    established: 1999,
    description: '정밀 기계 가공 기술로 선박 기관 부품을 제조하는 전문업체입니다.',
    specialties: ['피스톤', '실린더', '베어링', '밸브'],
    certifications: ['ISO 9001', 'KS 인증', '선급 인증'],
    employees: 58,
    annualProduction: '연 20억원',
    mainClients: ['한국원양산업', '대림수산', '한성기업'],
    contact: {
      phone: '055-283-4567',
      email: 'changwon@precision.co.kr',
      address: '경상남도 창원시 성산구 공단로 789'
    },
    image: 'https://readdy.ai/api/search-image?query=precision%20machinery%20workshop%20with%20marine%20engine%20pistons%20cylinders%20and%20bearings%20cnc%20machining%20equipment%20modern%20manufacturing%20facility&width=800&height=600&seq=manu11&orientation=landscape',
    rating: 4.9,
    reviewCount: 211
  },
  {
    id: 12,
    name: '속초해양용품',
    region: '강원 속초',
    category: '갑판용품 전문',
    established: 2007,
    description: '동해안 어선에 최적화된 갑판용품을 제조 및 공급하는 업체입니다.',
    specialties: ['어창 덮개', '갑판 매트', '작업 장갑', '안전 장비'],
    certifications: ['ISO 9001', '안전인증'],
    employees: 32,
    annualProduction: '연 9억원',
    mainClients: ['속초수협', '동해수산', '한성기업'],
    contact: {
      phone: '033-635-7890',
      email: 'sokcho@deckgear.co.kr',
      address: '강원도 속초시 해오름로 123'
    },
    image: 'https://readdy.ai/api/search-image?query=marine%20deck%20supplies%20warehouse%20with%20fish%20hold%20covers%20deck%20mats%20and%20safety%20equipment%20organized%20storage%20coastal%20facility&width=800&height=600&seq=manu12&orientation=landscape',
    rating: 4.6,
    reviewCount: 102
  }
];
